<template>
<v-menu
  v-model='visible'
  :close-on-content-click='false' nudge-bottom
  v-bind='menuAttrs' >
  <template v-slot:activator="{ on }">
    <v-chip v-on='on' slot='activator' small >
      <v-avatar left ><v-icon small >expand_more</v-icon></v-avatar>
      Mailchimp
    </v-chip>
  </template>
  <span>
    <v-card class='text-center' v-if='requests.get.loading' width='360px' >
      <center>
      <v-progress-circular class='ma-5' size=64 color='amber' indeterminate ></v-progress-circular>
      </center>
    </v-card>
    <v-card v-else width='400px' >
      <request-status :request='requests.save' ></request-status>
      <v-card-title class='subtitle-1 overline' >
        {{email}}
        <v-spacer></v-spacer>
        <v-chip class='v-chip--x-small' v-if='member && member.status' >{{member.status}}</v-chip>
        <v-btn icon small @click='visible=false' class='mr-0' ><v-icon small>close</v-icon></v-btn>
      </v-card-title>
      <template v-if='requests.get.status === 404' >
        <v-card-text >
          This email is not in your Mailchimp mailing list.
          Would you like to add them?
        </v-card-text>
        <v-card-actions >
          <v-spacer></v-spacer>
          <v-btn @click="save"
            small color='primary' >Add to Mailchimp</v-btn>
        </v-card-actions>
      </template>
      <template v-if='member && requests.get.status === 200' >
        <v-card-text >
          <strong>Email client:</strong> {{member.email_client || "Unknown" }}<br/>
          <v-layout row class='my-2' v-if='member.stats' >
            <v-flex>
              <strong >Open rate</strong>
              <v-progress-circular :rotate='270' :size='36' width='3' color='success' class='ml-2' :value="asPercent(member.stats.avg_open_rate)" >
                {{ asPercent(member.stats.avg_open_rate) }}%
              </v-progress-circular>
            </v-flex>
            <v-flex>
              <strong>Click rate:</strong>
              <v-progress-circular :rotate='270' :size='36' width='3' color='info' class='ml-2' :value="asPercent(member.stats.avg_click_rate)" >
                {{ asPercent(member.stats.avg_click_rate) }}%
              </v-progress-circular>
            </v-flex>
            <v-flex>
            <div class='overline' >Mailchimp rating</div>
            <v-rating half-increments small dense readonly
              v-model="member.member_rating">
            </v-rating>
          </v-flex>
          </v-layout>

          <strong>Last changed</strong> {{ dateformat(member.last_changed) }}
          <!-- <pre>{{member}}</pre> -->
          <div class='mt-2' v-if='member.tags && member.tags.length > 0' >
            <v-chip class="v-chip--x-small" outline outlined
              v-for='tag in member.tags'
              :key='tag.id' >
              {{ tag.name }}
            </v-chip>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions >
          <v-btn small color='primary'
            v-if='relationshipId && this.member && this.member.id'
            :loading='requests.save.loading'
            @click='save' >Update</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if='mailchimpURL'
            :href='mailchimpURL' target='_blank'
            small color='success' >Open in Mailchimp <v-icon class='ml-2' small>open_in_new</v-icon></v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </span>
</v-menu>
</template>
<script>
import RequestStatus from '@/components/ui/RequestStatus'
export default {
  name: 'MailchimpChip',
  props: {
    email: { type: String, required: true },
    relationshipId: { required: true },
    menuAttrs: { type: Object, required: false, default: () => {} }
  },
  components: {RequestStatus},
  data () {
    return {
      visible: false,
      requests: {
        get: {
          resource: 'ag.integrations',
          extra: 'mailchimp/member',
          result: {}
        },
        save: {
          resource: 'ag.integrations',
          extra: 'mailchimp/member',
          result: {}
        }
      }
    }
  },
  watch: {
    visible () {
      if (this.visible) {
        this.get()
      }
    },
    saveStatus () {
      if (this.saveStatus === 200) {
        this.get()
      }
    }
  },
  methods: {
    get () {
      this.requests.get.params = {email: this.email}
      this.$request('get', this.requests.get)
    },
    save () {
      this.requests.save.data = {
        relationship_id: this.relationshipId,
        mailchimp_id: this.member.id
      }
      console.log(this.requests.save.data)
      this.$request('save', this.requests.save)
    },
    asPercent (val) {
      if (val) { return Math.round(val * 100) }
      return 0
    }
  },
  computed: {
    member () {
      return this.requests.get.result
    },
    saveStatus () {
      return this.requests.save.status
    },
    mailchimpURL () {
      if (this.member && this.member._links && this.member._links.length > 0) {
        let url = this.member._links[0].targetSchema
        let urlBits = url.split('/schema/')
        let path = '/lists/members/view?id='
        if (urlBits.length > 0) {
          let base = urlBits[0].replace('.api.', '.admin.')
          return `${base}${path}${this.member.web_id}`
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// MailchimpChip.vue?048793f9